const state = () => ({
    lang: localStorage.getItem('lang') || 'ru',
    langs: [
      {label: 'Русский', value: 'ru'},
      {label: 'Английский', value: 'en'},
    ]
})

const getters = {
  getLang(state) {
    return state.lang;
  },
  getLangs(state) {
    return state.langs;
  }
}

const mutations = {
  setLang(state, lang) {
    state.lang = lang;
  }
}

const actions = {
  updateLang({ commit }, language) {
    commit('setLang', language);
  }
};

export default {state, getters, mutations, actions};
